import {EditLeadStatusApiDto, LeadStatusApiDto} from "../../api/model/rest";
import {LeadStatusCategoryEnum} from "./LeadStatusCategory";
import JsonConverter from "../../api/helper/JsonConverter";

export default class LeadStatus {

	/**
	 * Lead status object.
	 * @param {string} id Lead status id.
	 * @param label Lead status label.
	 * @param category Lead status category.
	 * @param showPushNotification
	 */
	constructor(public readonly id: string,
		public readonly label: string,
		public readonly category: string,
		public readonly showPushNotification: boolean) {}

	static fromJson(json: LeadStatusApiDto): LeadStatus {
		return new LeadStatus(json.id, json.label, json.category, json.showPushNotification);
	}

	toJson(): EditLeadStatusApiDto {
		const json: EditLeadStatusApiDto = {
			label: this.label,
			category: this.category,
			showPushNotification: this.showPushNotification
		};
		return JsonConverter.removeEmptyFields(json);
	}

	/**
	 * @returns {string} lead status display label.
	 */
	public getStatusLabel(): string {
		return this.label;
	}

	/**
	 * Get icon for given status.
	 * @return {string}
	 */
	public getStatusIcon() {
		switch (this.category) {
			case LeadStatusCategoryEnum.Pending:
				return "icn-act-new.svg";
			case LeadStatusCategoryEnum.Won:
				return "icn-act-won.svg";
			case LeadStatusCategoryEnum.Lost:
				return "icn-act-lost.svg";
			default:
				return "icn-act-new.svg";
		}
	}
}
